import type { VoidFunctionComponent } from 'react';

import Flex from '../../generic/Flex';
import Toggle from '../../generic/Toggle';

type CVEFilterComponentProps = {
  title: string;
  description: string;
  isEnabled: boolean;
  onToggle: () => void;
};

const CVEFilterComponent: VoidFunctionComponent<CVEFilterComponentProps> = ({
  title,
  description,
  isEnabled,
  onToggle,
}) => {
  return (
    <div className="card cve-status-container">
      <div className="cve-status-details">
        <span className="cve-status-title">{title}</span>
        <div className="cve-status-description">
          {description}
        </div>
      </div>
      <Flex gap={10}>
        <Toggle
          checked={isEnabled}
          onChange={onToggle}
        />
        <div className="cve-status-toggle-label">
          {isEnabled ? 'Enabled' : 'Disabled'}
        </div>
      </Flex>
    </div>
  );
};

export default CVEFilterComponent;
